import React, { useEffect } from 'react';
import { Form } from 'formik';
import { Upload, Button, Checkbox, Row, Col, Select, Tooltip } from 'antd';
import HostedTableFooter from './HostedTableFooter';
import { InputWithIcon } from 'components-shared/inputs/InputWithIcon';
import Icon from 'components/Icon';
import { useSelector } from 'react-redux';
import { HOSTED_TABLE_TABS } from './HostedLookupTablesList';
import { FaInfoCircle } from 'react-icons/fa';
import styled from 'styled-components';

 const FaInfoCircleStyle = styled(FaInfoCircle)`
    cursor: pointer;
    margin-left: 3px;
    opacity: 0.5;
    margin-top: 6px;
  `;

const UploadHostedCSVForm = ({
  values,
  cancelForm,
  setFieldValue,
  errors,
  touched,
  setTouched,
  showPreview,
  activeTab,
  isEdit = false,
  kFormatter,
  setFieldTouched,
  initialValues
}) => {
  const tablePrefix = useSelector((state) => state.hostedTables.tablePrefix);
  const conversationTablePrefix = useSelector((state) => state.hostedTables.conversationTablePrefix);
  const shownTablePrefix = activeTab === HOSTED_TABLE_TABS.CONVERSATIONAL_TABLES ? conversationTablePrefix : tablePrefix;

  const tableNameForEdit = values?.tableName || '';
  const underscoreIndex = tableNameForEdit?.indexOf("_");
  const prefixForEdit = underscoreIndex !== -1 ? tableNameForEdit?.substring(0, underscoreIndex + 1) : "";
  const restNameForEdit = underscoreIndex !== -1 ? tableNameForEdit?.substring(underscoreIndex + 1) : tableNameForEdit;


  const delimiterList = [
    { value: ',', label: 'Comma (,)' },
    { value: ';', label: 'Semi Colon (;)' },
    { value: '|', label: 'Pipe (|)' },
  ];

  const uploadProps = {
    accept: '.csv, text/csv',
    beforeUpload: (file) => {
      setFieldValue('file', file, false); // don't validate yet
      setTimeout(() => {
        setFieldTouched('file', true);
      }, 0);
      return false;
    },
    onRemove: () => {
      setFieldValue('file', null, false);
      setTimeout(() => {
        setFieldTouched('file', true);
      }, 0);
    },
    fileList: values.file ? [values.file] : [],
  };

  useEffect(() => {
    if (values.file) {
      setTouched({ ...touched, file: true });
    }
  }, []);

  return (
    <Form className="k-form scroll-content-modal">
      <Row>
        <Col span={24}>
          <InputWithIcon
            style={{ textTransform: 'uppercase' }}
            required
            title="Table Name"
            field="tableName"
            placeholder="Enter Table name"
            value={
              isEdit
                ? restNameForEdit
                : values.tableName
            }
            icon={<Tooltip title="Table Prefix">{isEdit ? prefixForEdit : shownTablePrefix}</Tooltip>}
            disabled={isEdit}
            iconStyle={{ width: activeTab === HOSTED_TABLE_TABS.CONVERSATIONAL_TABLES ? '45px' : '35px' }}
          />
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Checkbox
            checked={values.uploadData}
            onChange={(e) => setFieldValue('uploadData', e.target.checked)}
            disabled={activeTab === HOSTED_TABLE_TABS.CONVERSATIONAL_TABLES}
          >
            Upload Data
          </Checkbox>
        </Col>
      </Row>

      {!values.uploadData && (
        <Row>
          <Col span={24}>
            <InputWithIcon
              type="number"
              required
              title="Number of columns"
              field="numberOfColumn"
              placeholder="Enter Number of columns"
              value={values.numberOfColumn}
              icon={null}
            />
          </Col>
        </Row>
      )}

      {values.uploadData && (
        <>
          {activeTab === HOSTED_TABLE_TABS.TABLES && (
            <Row>
              <Col span={24}>
                <Checkbox
                  checked={values.containsHeader}
                  onChange={(e) => setFieldValue('containsHeader', e.target.checked)}
                >
                  CSV Contains Headers
                </Checkbox>
              </Col>
            </Row>
          )}

          <Row>
            <Col span={24}>
              <label className="k-form-field">
                <span className="input-label">Separator Type</span>
                <div className="input-icon-wrapper">
                  <Select
                    value={values.delimiter}
                    style={{ width: '100%' }}
                    onChange={(value) => setFieldValue('delimiter', value)}
                    options={delimiterList}
                  />
                </div>
              </label>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <label className="k-form-field">
                <Upload {...uploadProps}>
                  <Button className="required-field">
                    <Icon type="upload" /> Select CSV File
                  </Button>
                </Upload>
              </label>
              {/* {touched?.file && errors.file && <div className="form-error">{errors.file}</div>} */}
              {errors.file && (touched.file || values.file) && (
                  typeof errors.file === 'string' ? (
                    <div className="form-error">{errors.file}</div>
                  ) : (
                    <div className="form-error">
                      {errors.file.message}
                      <Tooltip
                        title={
                          <div className="text-left">
                            <div><strong>Expected columns:</strong></div>
                            <div className="mb-1">{errors.file.expected.join(', ')}</div>

                            {errors.file.missing?.length > 0 && <><div><strong>Missing columns:</strong></div>
                            <div className="mb-1 text-yellow-600">{errors.file.missing.join(', ')}</div> </> }
                            {errors.file.extra?.length > 0 && <><div><strong>Extra columns:</strong></div>
                              <div className="mb-1 text-yellow-600">{errors.file.extra.join(', ')}</div> </> }
                            <div><strong>Columns in CSV:</strong></div>
                            <div>{errors.file.csvColumns.join(', ')}</div>
                          </div>
                        }
                        placement="right"
                        overlayStyle={{ maxHeight: '400px', overflowY: 'auto' }}
                      >
                        {/* <Info size={16} className="cursor-pointer text-blue-500" /> */}
                        
                        I <FaInfoCircleStyle />
                      </Tooltip>
                    </div>
                  )
                )}
            </Col>
          </Row>
        </>
      )}

      <HostedTableFooter
        showPreview={() => showPreview(values.file, values.delimiter, values.containsHeader, values.tableName)}
        previewDisabled={!values.file || !!errors.file || !values.uploadData}
        disabled={Object.keys(errors).length > 0}
        cancelForm={cancelForm}
        initialValues={initialValues}
        values={values}
      />
    </Form>
  );
};

export default UploadHostedCSVForm;
